<script type="text/jsx" lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import planCommonMixin from '@/plans/EVENT_SAAS/mixin';
import { sortBy } from 'lodash';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { isEventSaasOrEventSassCore } from '@/common/constants';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';
import { isCurrencySwitch } from '@/utils/currency';
import { getPlanUnitByQuantity, planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, planCommonMixin],
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed: {
    showRemove() {
      // Hack: plan remove logic places in mx_remove when the user is from shopping bag
      if(isFromShoppingCart()) {
        return true;
      }
      const fromPlanType = getPlanTypeByCategory(pageConfig.plan);
      return fromPlanType !== this.planType;
    }
  },
  methods: {
    attendeesName(plan) {
      // If plan is PPA, return license unit
      if (plan?.isPPA && isCurrencySwitch()) {
        return getPlanUnitByQuantity(planUnitMap.license, 1);
      }
      // Default fallback
      return isEventSaasOrEventSassCore(this.planType) ? this.$t('billing.events.attendees', ['']) : this.$t('billing.participants');
    },
    renderConsumptionPlanList(list = []) {
      if (!list.length) return;
      const plan = list[0];

      return <div class="opc-cart-item" key={plan.plan_code} >
        {this.mx_title(`${this.$t(plan.typeNameKey)} ${this.$t('billing.events.ppa.title')}`, this.mx_price(plan), plan?.plan_code)}
        {this.mx_discount(plan.plan_code)}
        {this.renderAttendeeDesc(plan)}
        {this.mx_edit(plan)}
        {this.showRemove ? this.mx_remove(plan) : null}
      </div>
    },
    renderSaasPlanList(list = []) {
      if (!list.length) return;
      const targetItem = list.some(plan => !!plan.isOnlineFreeTrial)
      return <div class="opc-cart-item">
        {/* FREE TRIAL - Specific UI for free trial */}
        { targetItem?
          this.mx_freeTrialTitle(this.title, undefined, list?.[0]?.parent_category) : this.mx_main_title(this.title, undefined, list?.[0]?.parent_category)}
        {sortBy(list, 'capacity').map((plan) => {
          return this.renderSaasPlan(plan);
        })}
      </div>
    },
    renderSaasPlan(plan) {
      if(!plan || !plan.cartInfo) return null;
      const quantity = plan.cartInfo.selected_number;
      {/* FREE TRIAL - Specific UI for free trial */}
      if(!!plan.isOnlineFreeTrial && !!plan.trialDays) {
        return (
            <div key={plan.plan_code} >
              {this.mx_freeTrialDesc(plan.trialDays)}
              {this.mx_new_license(plan, quantity)}
              {this.mx_freeTrialStartDate()}
              {this.mx_cycle(plan.billing_cycle)}
              {this.mx_edit(plan)}
              {this.showRemove ? this.mx_remove(plan) : null}
            </div>
        )
      }
      return (
        <div class="opc-cart-item__group" key={plan.plan_code} >
          {this.mx_subTitle(`${plan.capacity} ${this.attendeesName(plan)}`, <AltProratedPlanPrice type={plan.type} code={plan.plan_code}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>, plan?.plan_code)}
          {this.mx_discount(plan.plan_code)}
          {this.mx_cycle(plan.billing_cycle)}
          <AltProratedPlanUser type={plan.type} code={plan.plan_code}>{this.mx_new_license(plan, quantity)}</AltProratedPlanUser>
          <AltProratedPlanPeriod type={plan.type} code={plan.plan_code} />
          {this.mx_edit(plan)}
          {this.showRemove ? this.mx_remove(plan) : null}
        </div>
      );
    },
    renderAttendeeDesc(plan) {
      const cssClass = isCurrencySwitch() ? "opc-cart-item__attendee opc-cart-item__attendee--currency-switch" : "opc-cart-item__attendee";
      return <p class={cssClass}>{plan.capacity} {this.attendeesName(plan)}</p>
    },
    $renderPrice() {
      const saasPlans = this.mx_plans.filter((p) => p.isSaas);
      const ppaPlans = this.mx_plans.filter((p) => p.isPPA);

      return <div>
        {this.renderSaasPlanList(saasPlans)}
        {this.renderConsumptionPlanList(ppaPlans)}
      </div>
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>

<style lang="scss">
.opc-cart-item {
  &__attendee {
    color: var(--zoom-color-text-neutral);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    text-transform: capitalize;

    &--currency-switch {
      text-transform: none;
    }
  }

  &__unit {
    color: var(--zoom-color-text-neutral);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
  }
}
</style>
